/**
 * Cognito access token + username for dashboard query-string auth.
 * Prefer localStorage (set at login); fall back to Amplify session.
 */
import { Auth } from "aws-amplify";

function isUsable(value) {
  return value && value !== "null" && value !== "undefined";
}

export async function getDashboardAccessCreds() {
  let accessToken = localStorage.getItem("accessToken");
  let accessUser = localStorage.getItem("accessUser");

  if (isUsable(accessToken) && isUsable(accessUser)) {
    return { accessToken, accessUser };
  }

  const user = await Auth.currentAuthenticatedUser();
  accessToken = user.signInUserSession.accessToken.jwtToken;
  accessUser = user.username;
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("accessUser", accessUser);
  return { accessToken, accessUser };
}
